// extracted by mini-css-extract-plugin
export default {"newOtp":"StatusDetails_newOtp__p7JfG","progressBar":"StatusDetails_progressBar__GOBKA","details":"StatusDetails_details__5XgN8"};